const getDeviceInfo = (userAgent: string) => {
  const deviceInfoRegex = /\(([^)]+)\)/;
  const match = userAgent.match(deviceInfoRegex);

  return match ? match[1] : 'Unknown';
};

export default getDeviceInfo;
